import * as React from 'react'
import { SVGProps } from 'react'
const ChatIcon34 = ({
  fill = '#2B4D5F',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={35}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={fill}
        d="M16 32.5c8.837 0 16-7.163 16-16S24.837.5 16 .5 0 7.663 0 16.5s7.163 16 16 16Z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.28 23.825c.704-.05 1.401-.163 2.084-.34a5.7 5.7 0 0 0 2.602.17c.034-.005.07-.007.104-.008.31 0 .717.18 1.31.56v-.625a.61.61 0 0 1 .311-.531c.259-.147.498-.313.717-.499.864-.732 1.352-1.708 1.352-2.742a3.28 3.28 0 0 0-.159-1.006c.262-.488.471-.998.627-1.53A4.6 4.6 0 0 1 26 19.81c0 1.405-.654 2.715-1.785 3.673-.189.16-.388.307-.595.442v1.461c0 .503-.58.792-.989.493-.387-.29-.787-.56-1.2-.81a2.999 2.999 0 0 0-.368-.187c-.34.051-.687.077-1.039.077-1.412 0-2.717-.423-3.744-1.134Zm-7.466-2.922C7.03 19.39 6 17.329 6 15.12 6 10.607 10.258 7 15.457 7c5.199 0 9.458 3.607 9.458 8.12 0 4.514-4.259 8.121-9.458 8.121a11 11 0 0 1-1.728-.135c-.245.058-1.224.64-2.635 1.67-.511.374-1.236.013-1.236-.616v-2.492a9.001 9.001 0 0 1-1.044-.765Zm4.949.666a.85.85 0 0 1 .13.01c.51.086 1.034.13 1.564.13 4.392 0 7.907-2.978 7.907-6.589 0-3.61-3.515-6.588-7.907-6.588-4.39 0-7.907 2.978-7.907 6.588 0 1.746.821 3.39 2.273 4.62.367.31.765.587 1.196.832.241.136.39.39.39.664v1.437c1.116-.749 1.85-1.104 2.354-1.104Zm-2.337-4.916c-.685 0-1.24-.55-1.24-1.226 0-.677.555-1.226 1.24-1.226.685 0 1.24.549 1.24 1.226 0 .677-.555 1.226-1.24 1.226Zm4.031 0c-.685 0-1.24-.55-1.24-1.226 0-.677.555-1.226 1.24-1.226.685 0 1.24.549 1.24 1.226 0 .677-.555 1.226-1.24 1.226Zm4.031 0c-.685 0-1.24-.55-1.24-1.226 0-.677.555-1.226 1.24-1.226.685 0 1.24.549 1.24 1.226 0 .677-.555 1.226-1.24 1.226Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .5h34v34H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default ChatIcon34
